import { createAction } from '@reduxjs/toolkit'

import { EconomySet } from 'types/GlobalEconomySets'

// tryGetAllEconomySets
export const getAll = createAction('get_all_economy_sets')
export const getAllSuccess = createAction<EconomySet[]>(
  'get_all_economy_sets_success'
)
export const getAllFailed = createAction('get_all_economy_sets_failed')

// tryCreateEconomySet
export const create = createAction('create_economy_set')
export const createSuccess = createAction<EconomySet>(
  'create_economy_set_success'
)
export const createFailed = createAction('create_economy_set_failed')

// tryDuplicateEconomySet
export const duplicate = createAction('duplicate_economy_set')
export const duplicateSuccess = createAction<EconomySet>(
  'duplicate_economy_set_success'
)
export const duplicateFailed = createAction('duplicate_economy_set_failed')

// tryUpdateEconomySet
export const update = createAction('update_economy_set')
export const updateSuccess = createAction<EconomySet>(
  'update_economy_set_success'
)
export const updateFailed = createAction('update_economy_set_failed')

// tryUpdateEconomySetCompanies
export const updateCompanies = createAction('update_economy_set_companies')
export const updateCompaniesSuccess = createAction<EconomySet>(
  'update_economy_set_companies_success'
)
export const updateCompaniesFailed = createAction(
  'update_economy_set_companies_failed'
)

// tryDeleteEconomySet
export const destroy = createAction('delete_economy_set')
export const destroySuccess = createAction<{ id: string }>(
  'delete_economy_set_success'
)
export const destroyFailed = createAction('delete_economy_set_failed')

// tryUploadEconomySet
export const upload = createAction('upload_economy_set')
export const uploadSuccess = createAction<EconomySet>(
  'upload_economy_set_success'
)
export const uploadFailed = createAction('upload_economy_set_failed')
